export enum IconType {
  Filled = 'ki-filled',
  Solid = 'ki-solid',
  Duotone = 'ki-duotone',
  Outline = 'ki-outline',
}

export type IconProps = { type?: IconType; className?: string }
